module.exports = __webpack_public_path__ + "img/dymo.43ae8c68.jpg";